import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function RoleManager() {
	const permissionsArray = [
		'Can Edit Charges',
		'Can delete Charges',
		'Can update Charges',
		'Can view Charges',
	];
	const Patient = [
		'Can Edit Charges',
		'Can delete Charges',
		'Can view Charges',
	];

	return (
		<Grid container item xs={12} lg={12} sm={12} xl={12} md={12}>
			<Grid
				container
				item
				xs={12}
				lg={12}
				sm={12}
				xl={12}
				md={12}
				sx={{ border: '1px solid #E3E0E0', padding: ' 7px 2px 7px 2px' }}
			>
				<Grid item xs={3} lg={3} sm={3} xl={3} md={3}>
					<Typography
						variant="body1"
						sx={{
							fontFamily: 'Poppins',
							color: '#8E8585',
							fontSize: '19px',
							fontWeight: '500',
						}}
					>
						Actions
					</Typography>
				</Grid>
				<Grid item xs={3} lg={3} sm={3} xl={3} md={3}>
					<Typography
						variant="body1"
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
							fontSize: '19px',
							fontWeight: '500',
						}}
					>
						Biller
					</Typography>
				</Grid>
				<Grid item xs={3} lg={3} sm={3} xl={3} md={3}>
					<Typography
						variant="body1"
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
							fontSize: '19px',
							fontWeight: '500',
						}}
					>
						Manager
					</Typography>
				</Grid>
				<Grid item xs={3} lg={3} sm={3} xl={3} md={3}>
					<Typography
						variant="body1"
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
							fontSize: '19px',
							fontWeight: '500',
						}}
					>
						Admin
					</Typography>
				</Grid>
			</Grid>
			<Grid
				item
				xs={12}
				lg={12}
				sm={12}
				xl={12}
				md={12}
				sx={{
					border: '1px solid #E3E0E0',
					padding: ' 12px 2px 12px 2px',
					background: '#F5F5F5',
				}}
			>
				<Typography
					variant="body1"
					sx={{
						fontFamily: 'Poppins',
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						color: '#5B5C5C',
						fontSize: '19px',
						fontWeight: '500',
					}}
				>
					<DashboardIcon />
					Dashboard
				</Typography>
			</Grid>
			{permissionsArray.map((permission, index) => (
				<Grid
					key={index}
					container
					item
					xs={12}
					lg={12}
					sm={12}
					xl={12}
					md={12}
					sx={{
						borderBottom: '1px solid #E4E4E4',
						padding: '2px',
						borderLeft: '1px solid #E4E4E4',
						borderRight: '1px solid #E4E4E4',
					}}
				>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{ display: 'flex', alignItems: 'center' }}
					>
						<Typography
							variant="body1"
							sx={{
								fontFamily: 'Poppins',
								color: '#696363',
								fontSize: '16px',
								fontWeight: '400',
							}}
						>
							{permission}
						</Typography>
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
				</Grid>
			))}

			{/* <Grid container  item xs={12} lg={12} sm={12} xl={12} md={12}  sx={{ borderBottom:'1px solid #E4E4E4',padding:'2px', borderLeft:'1px solid #E4E4E4', borderRight:'1px solid #E4E4E4' }} >
        <Grid item xs={3} lg={3} sm={3} xl={3} md={3} sx={{ display:'flex', alignItems:'center' }} >
             <Typography variant='body1' sx={{ fontFamily:'Poppins', color:'#696363', fontSize:'16px', fontWeight:'400' }}>
                    Can Edit Charges
              </Typography>
        </Grid>
        <Grid item xs={3} lg={3} sm={3} xl={3} md={3}  sx={{ fontFamily:'Poppins',textAlign:'center' , color:'#8E8585', }} >
              {<Checkbox />}
            </Grid>
        <Grid item xs={3} lg={3} sm={3} xl={3} md={3}  sx={{ fontFamily:'Poppins',textAlign:'center' , color:'#8E8585', }} >
              {<Checkbox />}
            </Grid>
        <Grid item xs={3} lg={3} sm={3} xl={3} md={3}  sx={{ fontFamily:'Poppins',textAlign:'center' , color:'#8E8585', }} >
              {<Checkbox />}
            </Grid>
      </Grid> */}
			<Grid
				item
				xs={12}
				lg={12}
				sm={12}
				xl={12}
				md={12}
				sx={{
					border: '1px solid #E3E0E0',
					padding: ' 12px 2px 12px 2px',
					background: '#F5F5F5',
				}}
			>
				<Typography
					variant="body1"
					sx={{
						fontFamily: 'Poppins',
						display: 'flex',
						alignItems: 'center',
						gap: 1,
						color: '#5B5C5C',
						fontSize: '19px',
						fontWeight: '500',
					}}
				>
					<AccountCircleIcon />
					Patient
				</Typography>
			</Grid>
			{Patient.map((patient, index) => (
				<Grid
					key={index}
					container
					item
					xs={12}
					lg={12}
					sm={12}
					xl={12}
					md={12}
					sx={{
						borderBottom: '1px solid #E4E4E4',
						padding: '2px',
						borderLeft: '1px solid #E4E4E4',
						borderRight: '1px solid #E4E4E4',
					}}
				>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{ display: 'flex', alignItems: 'center' }}
					>
						<Typography
							variant="body1"
							sx={{
								fontFamily: 'Poppins',
								color: '#696363',
								fontSize: '16px',
								fontWeight: '400',
							}}
						>
							{patient}
						</Typography>
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
					<Grid
						item
						xs={3}
						lg={3}
						sm={3}
						xl={3}
						md={3}
						sx={{
							fontFamily: 'Poppins',
							textAlign: 'center',
							color: '#8E8585',
						}}
					>
						<Checkbox />
					</Grid>
				</Grid>
			))}
		</Grid>
	);
}

export default RoleManager;
